import axios from "axios";
import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'
  function PharmInvoiceOther(props) {
      const {sale_pharm} = useParams();
      const [opbillData, setopbillData] = useState([]);
      const [hospData, setHospData] = useState([]);
      const [viewPharmData, setViewPharmData] = useState([]);
      useEffect(() => {
            try{
                axios.get(baseUrl+'pharm-invoice-other/'+sale_pharm)
                .then(function (response) {
                    setopbillData(response.data);
                });
            }catch(error){
                console.log(error);
            }
            try {
              axios.get(baseUrl + "view-hospital/" + userLocation + "/").then(function (response) {
                setHospData(response.data);
              });
            } catch (error) {
              console.log(error);
            }
      },[]);

   useEffect(() => {
      if (opbillData.length > 0) {
        fetchPharmData();
      }
    }, [opbillData]);

function fetchPharmData() {
  const ipIds = opbillData.map(row => row.product.split(',').map(item => item.trim()));

  ipIds.forEach(ipId => {
    try {
      ipId.forEach(id => {
        axios.get(baseUrl + 'update-indent-use-bill/' + id + '/')
          .then(function (response) {
            const data = Object.assign({}, response.data);
            setViewPharmData(prevData => [...prevData, data]);
          })
          .catch(function (error) {
            console.log(error);
          });
      });
    } catch (error) {
      console.log(error);
    }
  });
}


const handlePrint = () => {
    const printContents = document.getElementById("invoice-print").innerHTML;
    const printStyles = `
        <style>
            body {
                font-family: 'Courier New', monospace !important;
                font-size: 12pt;
                line-height: 1.5;
                margin: 0;
                padding: 0;
                font-weight: bold;
            }
            @media print {
                .pharmacy-print-page {
                    width: 100%;
                    padding: 0.5in;
                }
                .pharmacy-print-page table {
                    width: 100%;
                    border-collapse: collapse;
                }
                .pharmacy-print-page table,
                .pharmacy-print-page th,
                .pharmacy-print-page td {
                    border: 1px solid black;
                    padding: 5px;
                    font-weight: bold;
                }
                .pharmacy-print-page th {
                    background-color: #eee;
                    font-weight: bold;
                }

            }
        </style>
    `;
    const originalContents = document.body.innerHTML;

    const printWindow = window.open('', '', 'height=800,width=800');
    printWindow.document.write('<html><head><title>Invoice</title>');
    printWindow.document.write(printStyles); // Add the styles here
    printWindow.document.write('</head><body>');
    printWindow.document.write(printContents);
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    printWindow.print();

    setTimeout(() => {
        window.location.reload();
    }, 1000);
};

const isNumeric = (value) => {
    return /^\d+$/.test(value);
};
function numberToWords(num) {
  const units = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
  const teens = ['eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
  const tens = ['', 'ten', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
  const scales = ['', 'thousand', 'million', 'billion', 'trillion', 'quadrillion', 'quintillion', 'sextillion', 'septillion', 'octillion', 'nonillion', 'decillion', 'undecillion', 'duodecillion', 'tredecillion', 'quattuordecillion', 'quindecillion', 'sexdecillion', 'septendecillion', 'octodecillion', 'novemdecillion', 'vigintillion'];

  function convertThreeDigitsLessThanThousand(num) {
    if (num === 0) return '';
    if (num < 10) return units[num];
    if (num < 20) return teens[num - 11];
    const onesDigit = num % 10;
    const tensDigit = Math.floor((num % 100) / 10);
    const hundredsDigit = Math.floor(num / 100);

    let result = '';
    if (hundredsDigit > 0) {
      result = `${units[hundredsDigit]} hundred`;
    }
    if (tensDigit > 0) {
      if (result) result += ' and ';
      if (tensDigit === 1) {
        result += teens[onesDigit];
      } else if (onesDigit === 0) {
        result += tens[tensDigit];
      } else {
        result += `${tens[tensDigit]}-${units[onesDigit]}`;
      }
    } else if (onesDigit > 0) {
      if (result) result += ' and ';
      result += units[onesDigit];
    }

    return result;
  }

  function convertThreeDigits(num) {
    if (num === 0) return 'zero';
    if (num < 1000) return convertThreeDigitsLessThanThousand(num);

    let words = '';
    let scaleIndex = 0;
    while (num > 0) {
      const currentNum = num % 1000;
      if (currentNum !== 0) {
        const currentWords = convertThreeDigitsLessThanThousand(currentNum);
        if (scaleIndex > 0) {
          words = `${currentWords} ${scales[scaleIndex]} ${words}`;
        } else {
          words = `${currentWords} ${words}`;
        }
      }
      scaleIndex++;
      num = Math.floor(num / 1000);
    }

    return words.trim();
  }
  if (num === 10000) {
    return 'ten thousand rupees only';
  }
  if (num === 0) {
    return 'zero rupees only';
  }

  if (num < 0) return `negative ${numberToWords(Math.abs(num))}`;

  const parts = num.toString().split('.');
  let integerPart = parseInt(parts[0], 10);
  let decimalPart = parseInt(parts[1], 10) || 0;

  let words = '';
  let scaleIndex = 0;

  // Convert integer part
  while (integerPart > 0) {
    const hundreds = integerPart % 1000;
    if (hundreds !== 0) {
      const hundredsWords = convertThreeDigits(hundreds);
      if (scaleIndex !== 0) {
        words = `${hundredsWords} ${scales[scaleIndex]} ${words}`;
      } else {
        words = `${hundredsWords} ${words}`;
      }
    }

    scaleIndex++;
    integerPart = Math.floor(integerPart / 1000);
  }

  // Convert decimal part
  if (decimalPart > 0) {
    words += ' and ';

    if (decimalPart < 10) {
      words += units[decimalPart];
    } else if (decimalPart < 20) {
      words += teens[decimalPart - 11];
    } else {
      const onesDigit = decimalPart % 10;
      const tensDigit = Math.floor(decimalPart / 10);

      if (onesDigit === 0) {
        words += tens[tensDigit];
      } else {
        words += `${tens[tensDigit]}-${units[onesDigit]}`;
      }
    }

    words += ' paisa';
  }

  words += ' rupees only';
  return words.trim();
}


      return (
          <section style={{ fontFamily: 'Courier New, monospace', fontWeight: 'bold' }} className="pharmacy-print-page">
          <div >
            {opbillData.map((row, index) =>
              <div id="invoice-print">
                <table rules="rows" cellpadding="3" className="text-justify mt-5" width="100%" >

                   <tr><th className="mx-0 ps-5" rowSpan="6">
                        <font>
                          Name : {isNumeric(row?.patient) ? row?.pat?.patient : row?.patient}
                        </font><br></br>
                        <font>PID : {row.pat?.pat_id}</font><br></br>
                        <font>Consultant : Dr.{row.cons?.consultant}</font>
                   </th></tr>
                   <tr><th className="mx-5 ps-5">
                        <font>Invoice No #:&nbsp;{row.sale_id}</font><br></br>
                        <font>Date :&nbsp;{row.add_date}</font><br></br>
                        <font>{row.mode.charAt(0).toUpperCase() + row.mode.slice(1)} Receipt</font>
                   </th></tr>
                </table>
                <div className="table-responsive">
                  <table border="2" rules="rows" cellpadding="3" className="text-justify mt-4" width="100%" >
                      <thead>
                        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
                           <th align="left">S.No</th>
                           <th align="left">HSN</th>
                           <th align="left">Product</th>
                           <th align="left">Batch No</th>
                           <th align="left">Expiry Date</th>
                           <th align="left">Packs</th>
                           <th align="left">MRP</th>
                           <th align="left">Qty</th>
                           <th align="left">CGST%</th>
                           <th align="left">SGST%</th>
                           <th align="left">Net Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                            {row.product.split(',').map((test, subIndex) => {
                              const pharmData = viewPharmData.find((data) => data.id == test);
                              return (
                                    <tr key={`${index}-${subIndex}`} style={{border: "1px solid", borderColor: "#2194d9"}}>
                                <td><b>{index + subIndex + 1}</b></td>
                                <td><b>{pharmData?.product.hsn}</b></td>
                                <td><b>{pharmData?.product.product}</b></td>
                                <td><b>{pharmData?.product.batch}</b></td>
                                <td><b>{pharmData?.product.expiry}</b></td>
                                <td><b>{pharmData?.product.pack}</b></td>
                                <td><b>Rs.{pharmData?.product.mrp}</b></td>
                                <td><b>{row.qty.split(',')[subIndex].trim()}</b></td>
                                <td><b>{pharmData?.product.sgst}</b></td>
                                <td><b>{pharmData?.product.cgst}</b></td>

                                <td>
                                  <b>
                                    Rs.
                                    {parseFloat(row.netamount.split(',')[subIndex].trim()).toFixed(2)}
                                  </b>
                                  </td>
                                </tr>
                              );
                            })}
                            <tr>
                                <td align="center" colSpan="6"></td>
                                <td align="left" style={{border: "1px solid", borderColor: "#2194d9"}}><b>Invoiced Amount</b></td>
                                <td align="left" style={{border: "1px solid", borderColor: "#2194d9"}}>
                                <b>Rs.{row.total}</b></td>
                            </tr>
                            {row.disc != 0 && row.disc != "" && row.disc != null && (
                              <tr>
                                <td align="center" colSpan="6"></td>
                                <td align="left" style={{border: "1px solid", borderColor: "#2194d9"}}><b>Discount Amount</b></td>
                                <td align="left" style={{border: "1px solid", borderColor: "#2194d9"}}>
                                <b style={{color: "red"}}>Rs.{row.disc}</b></td>
                              </tr>
                            )}
                            <tr>
                                <td align="center" colSpan="6"></td>
                                <td align="left" style={{border: "1px solid", borderColor: "#2194d9"}}><b>Paid Amount</b></td>
                                <td align="left" style={{border: "1px solid", borderColor: "#2194d9"}}>
                                <b>Rs.{row.paid}</b></td>
                            </tr>
                            {row.balance != 0 && row.balance != "" && (
                              <tr>
                                <td align="center" colSpan="6"></td>
                                <td align="left" style={{border: "1px solid", borderColor: "#2194d9"}}><b>Balance Amount</b></td>
                                <td align="left" style={{border: "1px solid", borderColor: "#2194d9"}}>
                                <b>Rs.{row.balance}</b></td>
                              </tr>
                            )}
                      </tbody>
                  </table>
                  <p className="mt-2 p-3 text-bold">Received the sum of {numberToWords(parseFloat(row.paid))}.</p>
                   <div style={{display: 'flex', justifyContent: 'right', alignItems: 'right' }}>
                   <tr>
                   <th>{row.addedby}</th>
                   <br></br>
                   <th style={{width: "150px", borderTop: "2px solid black"}}>Pharmacist</th></tr>
                   </div>
                </div>
              </div>
              )}
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <button style={{ padding: '5px 20px', borderRadius: '10px', backgroundColor: '#007bff', color: '#fff' }}
              onClick={handlePrint}
              >
               Print
              </button>
            </div>
          </div>
        </section>
      );

  }
export default PharmInvoiceOther;